document.addEventListener('Searchanise.Loaded', function() {
  (function($) {
    $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
      if ( type === 'results' && ( !data.totalItems || data.correctedQuery )) {
        params.action = 'none';
        window.location.href = '/pages/special-orders';
      }
    });
  })(window.Searchanise.$);
});